package com.clany.backoffice.data.repository

import com.clany.backoffice.data.network.KeycloakConfig
import com.clany.backoffice.data.network.NetworkClient
import com.clany.backoffice.data.network.response.AdvancedNotificationFilter
import com.clany.backoffice.data.network.response.FilterUsersRequest
import com.clany.backoffice.domain.repository.UserRepository
import com.clany.backoffice.model.UserResponse
import io.ktor.client.call.body
import io.ktor.client.request.get
import io.ktor.client.request.parameter
import io.ktor.client.request.patch
import io.ktor.client.request.post
import io.ktor.client.request.delete
import io.ktor.client.request.put
import io.ktor.client.request.setBody
import io.ktor.client.statement.bodyAsText
import io.ktor.http.ContentType
import io.ktor.http.contentType
import io.ktor.http.isSuccess
import kotlinx.serialization.Serializable
import dev.zacsweers.metro.Inject
import dev.zacsweers.metro.ContributesBinding
import com.clany.backoffice.di.AppScope
import dev.zacsweers.metro.SingleIn

@SingleIn(AppScope::class)
@ContributesBinding(AppScope::class)
@Inject
class UserRepositoryImpl(
    private val networkClient: NetworkClient
) : UserRepository {

    private val baseUrl = KeycloakConfig.API_URL

    override suspend fun getUsers(page: Int, pageSize: Int, query: String?): Result<List<UserResponse>> {
        return networkClient.request<List<UserResponse>>("$baseUrl/api/users") {
            parameter("page", page)
            parameter("limit", pageSize)
            if (query != null) parameter("q", query)
        }
    }

    override suspend fun updateUser(request: com.clany.backoffice.data.repository.UpdateUserRequest): Result<UserResponse> {
        return networkClient.request<UserResponse>("$baseUrl/api/users", io.ktor.http.HttpMethod.Put, request)
    }

    override suspend fun deleteUser(id: String): Result<Unit> {
        return networkClient.request<Unit>("$baseUrl/api/users/$id", io.ktor.http.HttpMethod.Delete)
    }

    override suspend fun updateUserRole(userId: String, role: String): Result<UserResponse> {
        return networkClient.request<UserResponse>("$baseUrl/api/users/$userId/role", io.ktor.http.HttpMethod.Patch, UpdateRoleRequest(role))
    }

    override suspend fun resetPassword(userId: String): Result<Unit> {
        return networkClient.request<Unit>("$baseUrl/api/users/$userId/reset-password", io.ktor.http.HttpMethod.Post)
    }

    override suspend fun filterUsers(filter: AdvancedNotificationFilter, page: Int, limit: Int): Result<List<UserResponse>> {
        return networkClient.request<List<UserResponse>>(
            "$baseUrl/api/users/filter",
            io.ktor.http.HttpMethod.Post,
            FilterUsersRequest(filter = filter, page = page, limit = limit)
        )
    }
}
